const subjectList = [
  {
    majorName: '数学',
    imgUrls:
      'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/examOutline/zyk/2025%E8%80%83%E7%A0%94%E6%95%B0%E5%AD%A6%E5%A4%A7%E7%BA%B2%E5%8F%98%E5%8A%A8%E5%AF%B9%E6%AF%94.pdf',
    pdfUrl:
      'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/examOutline/zyk/2025%E8%80%83%E7%A0%94%E6%95%B0%E5%AD%A6%E5%A4%A7%E7%BA%B2%E5%A4%87%E8%80%83%E7%AD%96%E7%95%A5.pdf',
  },
  {
    majorName: '英语',
    imgUrls: 'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/examOutline/zyk/2025%E8%80%83%E7%A0%94%E8%8B%B1%E8%AF%AD%E5%A4%A7%E7%BA%B2%E5%8F%98%E5%8A%A8.pdf',
    pdfUrl: 'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/examOutline/zyk/2025%E8%80%83%E7%A0%94%E8%8B%B1%E8%AF%AD%E5%A4%A7%E7%BA%B2%E5%8F%98%E5%8A%A8%E5%8F%8A%E5%A4%87%E8%80%83%E7%AD%96%E7%95%A5.pdf',
  },
  {
    majorName: '政治',
    imgUrls: '',
    pdfUrl: '',
  },
  {
    majorName: '经管',
    child: [
      {
        majorName: '199管综',
        imgUrls:
          'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/examOutline/zyk/2025%E8%80%83%E7%A0%94%E7%AE%A1%E7%BB%BC%E8%80%83%E7%A0%94%E5%A4%A7%E7%BA%B2%E5%8F%98%E5%8A%A8%E5%AF%B9%E6%AF%94.pdf',
        pdfUrl:
          'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/examOutline/zyk/2025%E8%80%83%E7%A0%94%E7%AE%A1%E7%BB%BC%E8%80%83%E7%A0%94%E5%A4%A7%E7%BA%B2%E5%A4%87%E8%80%83%E7%AD%96%E7%95%A5.pdf',
      },
      {
        majorName: '396经综',
        imgUrls:
          'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/examOutline/zyk/2025%E8%80%83%E7%A0%94%E7%BB%8F%E7%BB%BC%E8%80%83%E7%A0%94%E5%A4%A7%E7%BA%B2%E5%8F%98%E5%8A%A8%E5%AF%B9%E6%AF%94.pdf',
        pdfUrl:
          'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/examOutline/zyk/2025%E8%80%83%E7%A0%94%E7%BB%8F%E7%BB%BC%E8%80%83%E7%A0%94%E5%A4%A7%E7%BA%B2%E5%8F%98%E5%8A%A8%E5%A4%87%E8%80%83%E7%AD%96%E7%95%A5.pdf',
      },
    ],
  },
  {
    majorName: '专业课',
    child: [
      {
        majorName: '计算机408',
        imgUrls:
          'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/examOutline/zyk/25%E8%AE%A1%E7%AE%97%E6%9C%BA%E5%AD%A6%E7%A7%91%E4%B8%93%E4%B8%9A%E5%9F%BA%E7%A1%80%E8%80%83%E8%AF%95%E5%A4%A7%E7%BA%B2%E5%8F%98%E5%8A%A8%E5%AF%B9%E6%AF%94.pdf',
        pdfUrl:
          'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/examOutline/zyk/%E6%96%B0%E5%A4%A7%E7%BA%B2%E5%8F%91%E5%B8%83%E5%90%8E%E8%AE%A1%E7%AE%97%E6%9C%BA%E5%AD%A6%E7%94%9F%E5%BA%94%E8%AF%A5%E6%80%8E%E4%B9%88%E5%81%9A%EF%BC%9F.pdf',
      },
      {
        majorName: '法硕',
        imgUrls:
          'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/examOutline/zyk/2025%E8%80%83%E7%A0%94%E6%B3%95%E7%A1%95%E8%80%83%E7%A0%94%E5%A4%A7%E7%BA%B2%E5%8F%98%E5%8A%A8%E5%AF%B9%E6%AF%94.pdf',
        pdfUrl:
          'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/examOutline/zyk/2025%E8%80%83%E7%A0%94%E6%B3%95%E7%A1%95%E8%80%83%E7%A0%94%E5%A4%A7%E7%BA%B2%E5%A4%87%E8%80%83%E7%AD%96%E7%95%A5.pdf',
      },
      {
        majorName: '教育综合333',
        imgUrls: 'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/examOutline/zyk/25%E8%80%83%E7%A0%94%20%E6%95%99%E8%82%B2%E7%A1%95%E5%A3%AB%EF%BC%88333%EF%BC%89%E5%A4%A7%E7%BA%B2%E5%8F%98%E5%8A%A8.pdf',
        pdfUrl: 'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/examOutline/zyk/%E6%95%99%E8%82%B2%E5%AD%A6%E4%B8%93%E4%B8%9A%E5%A4%87%E8%80%83%E8%A7%84%E5%88%92.pdf',
      },
      {
        majorName: '教育学311',
        imgUrls: 'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/examOutline/zyk/25%E6%95%99%E8%82%B2%E5%AD%A6%E7%A1%95%E5%A3%AB%EF%BC%88311%EF%BC%89%E5%A4%A7%E7%BA%B2%E5%8F%98%E5%8A%A8.pdf',
        pdfUrl: 'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/examOutline/zyk/%E6%95%99%E8%82%B2%E5%AD%A6%E4%B8%93%E4%B8%9A%E5%A4%87%E8%80%83%E8%A7%84%E5%88%92.pdf',
      },
      {
        majorName: '西医',
        imgUrls: '',
        pdfUrl: '',
      },
      {
        majorName: '农学门类',
        imgUrls: '',
        pdfUrl: '',
      },
    ],
  },
];
const navTab = [
  {
    name: '大纲变动',
    img: 'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/examOutline/tab-icon1.png',
  },
  {
    name: '备考策略',
    img: 'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/examOutline/tab-icon2.png',
  },
];

export { subjectList, navTab };
